import { FC, useEffect, useState, ReactElement } from "react";

const SkeletonElement: FC<{ height: string; width: string }> = ({ height, width }) => {
  return (
    <>
      <div className="Skeleton" />
      {/* language=CSS */}
      <style jsx>
        {`
          @keyframes loading {
            0% {
              background-color: #f2f2f2;
            }
            50% {
              background-color: #ddd;
            }
            100% {
              background-color: #f2f2f2;
            }
          }

          .Skeleton {
            display: inline-block;
            height: ${height};
            width: ${width};
            background-color: #f2f2f2;
            overflow: hidden;
            position: relative;
            animation: loading 2s infinite linear;
          }
        `}
      </style>
    </>
  );
};

const Skeleton: FC<{ height: string; width?: string; lines?: number }> = ({
  height,
  width = "100%",
  lines = 1,
}) => {
  const [elements, setElements] = useState<ReactElement[]>([]);

  useEffect(() => {
    const lineElements: ReactElement[] = [];

    for (let i = 0; i < lines; i++) {
      lineElements.push(<SkeletonElement height={height} width={width} key={i} />);

      setElements(lineElements);
    }
  }, [lines]);

  return (
    <>
      {elements.map((element, index) => {
        return element;
      })}
    </>
  );
};

export default Skeleton;
